/** @format */

import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as CheckedIcon } from "images/svg/checked.svg";
import { ReactComponent as UnCheckedIcon } from "images/svg/unchecked.svg";
import Educat from "images/pic.png";
import { useUpdateNyscStatusMutation } from "store/services/adminAPI";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import {
  extractErrorMessage,
  replaceUnderscoresWithSpaces,
  capitalize,
} from "utils/strings";
import { useNavigate } from "react-router-dom";
import { Path } from "utils/constant.data";
import { ReactComponent as OneIcon } from "images/svg/nysc/one.svg";
import { ReactComponent as TwoIcon } from "images/svg/nysc/two.svg";
import { ReactComponent as GTwo } from "images/svg/nysc/gtwo.svg";
import { ReactComponent as Gthree } from "images/svg/nysc/gthree.svg";
import { ReactComponent as ThreeIcon } from "images/svg/nysc/three.svg";
import useIsMobile from "hooks/useMobile";

const NyscModal = ({ showPrompt, setShowPrompt, isNew }) => {
  const [updateNyscStatus, { isLoading: updating }] =
    useUpdateNyscStatusMutation();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [isNysc, setNysc] = useState(true);
  const isMobile = useIsMobile();

  const handleSubmit = async (values) => {
    save({ ...values, is_nysc: true });
  };

  const save = async (values) => {
    await updateNyscStatus(values)
      .unwrap()
      .then(() => {
        const message = `✔️ NYSC status updated !`;
        toast.success(message, {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
        });
        isNew ? setStep(3) : setShowPrompt(false);
      })
      .catch((error) => {
        const formattedError = extractErrorMessage(error);
        Swal.fire({
          title:
            replaceUnderscoresWithSpaces(error?.data?.code) || "Error Occured",
          text: capitalize(formattedError),
          iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
          showCloseButton: true,
          customClass: {
            icon: "no-border",
          },
          confirmButtonText: "Try Again",
        });
      });
  };
  const formik = useFormik({
    initialValues: {
      nysc_call_up_number: "",
      nysc_end_date: "",
    },
    validationSchema: LoginSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  const NoService = (
    <div className="modal-content">
      <div className="modal-body">
        <div className="d-flex flex-column">
          <h2>Are you currently serving with NYSC?</h2>
          <p>
            This helps us better tailor opportunities and experiences for you.
          </p>

          <div className="d-flex justify-content-between mb-3">
            <button
              type="button"
              className="nysc-option"
              onClick={() => setNysc(false)}
            >
              {isNysc ? <UnCheckedIcon /> : <CheckedIcon />}
              <span>No, I am not</span>
            </button>
            <button
              type="button"
              className="nysc-option"
              onClick={() => setNysc(true)}
            >
              {isNysc ? <CheckedIcon /> : <UnCheckedIcon />}
              <span>Yes, I am</span>
            </button>
          </div>

          {isNysc ? (
            <div className="d-flex flex-column">
              <form className="form mt-4" onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  <label className="mb-1">
                    <strong>Call-up Number</strong>
                  </label>

                  <div className="password__container">
                    <input
                      type="text"
                      className="form-control"
                      id="nysc_call_up_number"
                      name="nysc_call_up_number"
                      placeholder="E.g. NYSC/STC/2024/000000"
                      {...formik.getFieldProps("nysc_call_up_number")}
                    />
                  </div>

                  {formik.touched.nysc_call_up_number &&
                  formik.errors.nysc_call_up_number ? (
                    <div className="text-danger mt-2 fs-12">
                      {formik.errors.nysc_call_up_number}
                    </div>
                  ) : null}
                </div>

                <div className="mb-2">
                  <label className="mb-1">
                    <strong>Expected End of Service</strong>
                  </label>

                  <div className="password__container">
                    <input
                      type="date"
                      className="form-control"
                      id="nysc_end_date"
                      name="nysc_end_date"
                      placeholder="YY/MM"
                      {...formik.getFieldProps("nysc_end_date")}
                    />
                  </div>

                  {formik.touched.nysc_end_date &&
                  formik.errors.nysc_end_date ? (
                    <div className="text-danger mt-2 fs-12">
                      {formik.errors.nysc_end_date}
                    </div>
                  ) : null}
                </div>

                <div className="col-lg-12  w-100 d-flex justify-content-center mt-5">
                  <div className="form-group mb-3">
                    <button
                      type="submit"
                      className="submit btn btn-pigment-green"
                    >
                      {updating ? "Submitting..." : "Submit Response"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          ) : null}

          {!isNysc && (
            <div className="col-lg-12  w-100 d-flex justify-content-center">
              <div className="form-group mb-3">
                <button
                  type="button"
                  onClick={() => {
                    // setShowPrompt(false);
                    save({ is_nysc: false });
                  }}
                  className="submit btn btn-pigment-green"
                >
                  {updating ? "Submitting..." : "Submit Response"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const Service = (
    <div
      className="modal-content"
      style={{
        width: isMobile ? "auto" : "750px",
      }}
    >
      <div className="modal-body">
        <div className="d-flex">
          <div className={isMobile ? `d-none` : ` d-flex flex-column col-lg-4`}>
            <div className="d-flex flex-column">
              <div className="nysc-pointer">
                <OneIcon />
                <p className={step < 0 ? "" : "active"}>
                  A little welcome message for you
                </p>
              </div>
              <div className="nysc-pointer">
                {step < 2 ? <GTwo /> : <TwoIcon />}
                <p className={step < 2 ? "" : "active"}>
                  What is your NYSC Status
                </p>
              </div>
              <div className="nysc-pointer">
                {step < 3 ? <Gthree /> : <ThreeIcon />}
                <p className={step < 3 ? "" : "active"}>
                  Complete your Profile to get started
                </p>
              </div>
            </div>
          </div>

          <div className={isMobile ? "col-lg-12" : "col-lg-8"}>
            <p className="text-primary">Step {step} of 3</p>

            {step === 1 && (
              <div className="d-flex flex-column">
                <h2 className="mb-2">Welcome to 3MTT!</h2>
                <p className="mb-2">
                  You’re about to begin your journey into the world of digital
                  and technical skills.
                </p>
                <p className="mb-4">
                  Whether you're here to learn, grow, or transition into a tech
                  career. We’re excited to have you on board.
                </p>

                <h6 className="mb-2 font-bold">Here’s what happens next:</h6>

                <p>
                  <CheckedIcon />

                  <span className="ms-2">
                    You’ll soon be assigned to a cohort, and we will share
                    everything you need to get started, including schedules and
                    access to learning materials{" "}
                  </span>
                </p>
                <p className="mb-4">
                  <CheckedIcon />

                  <span className="ms-2">
                    You’ll be supported by facilitators and join a community of
                    peers on the same path
                  </span>
                </p>

                <h6>For now, sit tight, your journey is about to begin.</h6>

                <div className="col-lg-12  w-100 d-flex justify-content-center mt-5">
                  <div className="form-group mb-3">
                    <button
                      type="button"
                      onClick={() => setStep(2)}
                      className="submit btn btn-pigment-green"
                    >
                      Let’s get started!
                    </button>
                  </div>
                </div>
              </div>
            )}

            {step === 2 && (
              <div className="d-flex flex-column">
                <h2>Are you currently serving with NYSC?</h2>
                <p>
                  This helps us better tailor opportunities and experiences for
                  you.
                </p>

                <div className="d-flex justify-content-between mb-3">
                  <button
                    type="button"
                    className="nysc-option"
                    onClick={() => setNysc(false)}
                  >
                    {isNysc ? <UnCheckedIcon /> : <CheckedIcon />}
                    <span>No, I am not</span>
                  </button>

                  <button
                    type="button"
                    className="nysc-option"
                    onClick={() => setNysc(true)}
                  >
                    {isNysc ? <CheckedIcon /> : <UnCheckedIcon />}
                    <span>Yes, I am</span>
                  </button>
                </div>

                {isNysc ? (
                  <div className="d-flex flex-column mb-4">
                    <form className="form mt-4" onSubmit={formik.handleSubmit}>
                      <div className="mb-3">
                        <label className="mb-1">
                          <strong>Call-up Number</strong>
                        </label>

                        <div className="password__container">
                          <input
                            type="text"
                            className="form-control"
                            id="nysc_call_up_number"
                            name="nysc_call_up_number"
                            placeholder="E.g. NYSC/STC/2024/000000"
                            {...formik.getFieldProps("nysc_call_up_number")}
                          />
                        </div>

                        {formik.touched.nysc_call_up_number &&
                        formik.errors.nysc_call_up_number ? (
                          <div className="text-danger mt-2 fs-12">
                            {formik.errors.nysc_call_up_number}
                          </div>
                        ) : null}
                      </div>

                      <div className="mb-2">
                        <label className="mb-1">
                          <strong>Expected End of Service</strong>
                        </label>

                        <div className="password__container">
                          <input
                            type="date"
                            className="form-control"
                            id="nysc_end_date"
                            name="nysc_end_date"
                            placeholder="YY/MM"
                            {...formik.getFieldProps("nysc_end_date")}
                          />
                        </div>

                        {formik.touched.nysc_end_date &&
                        formik.errors.nysc_end_date ? (
                          <div className="text-danger mt-2 fs-12">
                            {formik.errors.nysc_end_date}
                          </div>
                        ) : null}
                      </div>

                      <div className="col-lg-12  w-100 d-flex justify-content-center mt-5">
                        <div className="form-group mb-3">
                          <button
                            type="submit"
                            className="submit btn btn-pigment-green"
                          >
                            {updating ? "Submitting..." : "Submit Response"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                ) : null}

                {!isNysc && (
                  <div className="col-lg-12  w-100 d-flex justify-content-center">
                    <div className="form-group mb-3">
                      <button
                        type="button"
                        onClick={() => {
                          // setShowPrompt(false);
                          save({ is_nysc: false });
                        }}
                        className="submit btn btn-pigment-green"
                      >
                        {updating ? "Submitting..." : "Submit Response"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {step === 3 && (
              <div className="d-flex flex-column">
                <h2>Complete your profile to get started</h2>
                <p>
                  Your profile helps us match you with the right learning track,
                  cohort, and resources.
                </p>
                <p>Let’s make sure your details are accurate and up to date.</p>

                <figure className="error-image">
                  <img
                    src={Educat}
                    alt="Empty Notice"
                    className="empty-notice-image"
                  />
                </figure>
                <div className="col-lg-12  w-100 d-flex justify-content-center">
                  <div className="form-group mb-3">
                    <button
                      type="button"
                      onClick={() => navigate(Path.FELLOW_PROFILE)}
                      className="submit btn btn-pigment-green"
                    >
                      Go to Profile
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      className="modal fade"
      show={showPrompt}
      style={{
        transform: isMobile ? "translate(0%, 20%)"  : isNew ? "translate(-5%, 20%)" : "translate(0,25%)",
      }}
    >
      {isNew ? Service : NoService}
    </Modal>
  );
};

export default NyscModal;

const LoginSchema = Yup.object().shape({
  nysc_call_up_number: Yup.string().required("NYSC Call-up Number is required"),
  nysc_end_date: Yup.date()
    .required("NYSC End Date is required")

    .min(new Date(), "Nysc End date cannot be in the past")
    .typeError("Please enter a valid date"),
});
